import React from 'react';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { BodyText2Css } from '@panel/commons/lib/typography';
import { Icon } from '../icon/Icon';

const StyledButton = styled.button`
  ${BodyText2Css}
  display: flex;
  align-items: center;
  padding: 13px 12px;
  border-radius: 8px;
  color: ${({ active }) => select(active ? 'darkGray' : 'black')};
  border: ${({ active }) => `1px solid ${select(active ? 'orange' : 'midDarkGray')}`};
  background: ${select('white')};
  font-weight: normal;
  :hover {
    border: ${({ active }) => `1px solid ${select(active ? 'orange' : 'darkGray')}`};
    cursor: pointer;
  }
  :disabled {
    cursor: not-allowed;
    color: ${select('lightGray')};
    background: ${select('midLightGray')};
    border: 0;
  }
`;

const DropdownPrimaryBtn = ({ text = '', active = false, disabled = false, onClick = () => {}, style, dataPanel }) => {
  return (
    <StyledButton
      as='button'
      onClick={onClick}
      active={active}
      disabled={disabled}
      style={style}
      data-panel={`container-selector-${dataPanel}`}
    >
      <span data-panel={`selector-${dataPanel}`}>{text}</span>
      <Icon name={active ? 'chevronUp' : 'chevronDown'} size={100} margin='0 0 0 8px' dataPanel={dataPanel} />
    </StyledButton>
  );
};

export default DropdownPrimaryBtn;
